import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
//import ReactPDF from '@react-pdf/renderer';
import { ArrowDropDown, AssessmentOutlined, Dataset, GroupSharp, RefreshSharp } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { format } from "date-fns";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
export default function ReportInterface() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [totalAmount, setTotalAmount] = useState(0);
  var subTotal = 0;

  const [groupBy, setGroupBy] = useState("SupplierName");
  var groupName = ""
  const [update, setUpdate] = useState(false);
  const {
    globalUser,
    globalRoleSecurity,
    setPageHeader,
    globalToken,
    allItems,
    globalSetting
  } = useContext(ShoppingCartContext);
  var currentDate = new Date()
  const [startDate, setStartDate] = useState(format(currentDate.setDate(currentDate.getDate() - parseInt(globalSetting?.filter(gs => gs.Description === "Home Page days Range").length ? globalSetting?.filter(gs => gs.Description === "Home Page days Range")[0].Value : 30
  )), "yyyy-MM-dd"))
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"))
  const [item, setItem] = useState("");
  const [itemVisible, setItemVisbile] = useState(false);
  //const [itemCategory,setItemCategory]=useState('')



  const [tableHeader, setTableHeader] = useState("");
  const [groupReport, setGroupReport] = useState(false);
  const [expandReport, setExpandReport] = useState({
    State: false,
    Module: "Purchase",
    Type: "General",
    Filter: true,
  });

  const styles = StyleSheet.create({
    page: {
      fontSize: 11,
      lineHeight: 1.5,
      padding: 15,
      paddingBottom: 50,
      height: '800',
    },
    header: {
      alignContent: "center",
      alignItems: "center",
      fontWeight: "bold",
      fontSize: 14,
      margin: 2,
    },
    orderHeader: {
      alignContent: "center",
      alignItems: "center",
      fontWeight: "bold",
      fontSize: 12,
      margin: 2,
    },
    table: {
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      margin: 2,
    },
    tableFilter: {
      flexDirection: "row",
      width: "100%",
    },
    tableRow: {
      margin: 0,
      flexDirection: "row",
      width: "100%",
      borderTopWidth: 1,
    },
    tableRowDetail: {
      margin: 0,
      flexDirection: "column",
      textAlign: "center",
      width: "100%",
      paddingLeft: 6,
      borderWidth: 1,
      borderTopWidth: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
    },

    tableCell: {
      margin: 0,
      paddingLeft: 5,
      fontSize: 8.25,
      width: "16%",
      height: 15,
      borderLeftWidth: 1,
      borderRightWidth: 1

    },
    tableCellWOBorder: {
      margin: 0,
      paddingLeft: 5,
      fontSize: 8.25,
      width: "16%",
      height: 15,
    },
    tableCellTotals: {
      margin: 0,
      paddingLeft: 5,
      fontSize: 8.25,
      flex: 1,
      height: 15,
      borderBottomWidth: 1
    },
    tableCellDetail: {
      margin: 0,
      fontSize: 8.25,
      width: "16%",
      height: 15,
      borderLeft: 1,
    },
    tableCellDetailTotals: {
      margin: 0,
      fontSize: 8.25,
      width: "16%",
      height: 15,
      border: 1,
      textAlign: "right",
      paddingRight: 3,
    },
    pageNumber: {
      position: 'absolute',
      marginTop: 800,
      paddingLeft: 10,
      width: "800",
      color: "gray",
      borderTop: 1,
    },
    logo: {
      width: "100%",
      height: 60,
      marginLeft: "auto",
      marginRight: "auto",
    },
  });
  const exportToExcel = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, tableHeader);
    //let buf = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, tableHeader + ".xlsx");
  };
  // Create Document Component
  const MyGeneralDocument = (props) => (

    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        {!(props.DataList === undefined) &&
          !(props.DataList === null) &&
          props.DataList?.length > 0 ? (
          <>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>
            <View style={[styles.header, { backgroundColor: "lightgray" }]}>
              <Text>{tableHeader}</Text>{" "}
            </View>
            <View style={styles.tableFilter}>
              <Text style={styles.tableCellWOBorder}>Filter</Text>
              <Text style={styles.tableCellWOBorder}>Start Date: {startDate}</Text>
              <Text style={styles.tableCellWOBorder}>End Date: {endDate}</Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}>
                Print Date :{format(new Date(), "yyyy-MM-dd")}{" "}
              </Text>
            </View>
            <View style={styles.table}>
              <View
                style={[
                  styles.tableRow,
                  {
                    backgroundColor: "lightgray",
                    fontWeight: "bold",
                    fontSize: "20",
                  },
                ]}
              >
                <Text style={[styles.tableCell, { marginLeft: 5, borderLeftWidth: 0 }]}>
                  Order Id
                </Text>
                <Text style={styles.tableCell}>Order Date</Text>
                <Text style={styles.tableCell}>{tableHeader?.includes("Sales") ? "Customer" : "Supplier"}</Text>
                <Text style={styles.tableCell}>Amount</Text>
                <Text style={styles.tableCell}>VAT Amount</Text>
                <Text style={[styles.tableCell, { borderRightWidth: 0 }]}>Total Amount</Text>
              </View>
              {props.DataList?.map((ord, index) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={[styles.tableCell, { marginLeft: 5, borderLeftWidth: 0 }]}>
                      {ord.OrderId}
                    </Text>
                    <Text style={styles.tableCell}>{ord.VoucherDate}</Text>
                    <Text style={styles.tableCell}>{tableHeader?.includes("Sales") ? ord.CustomerName : ord.SupplierName}</Text>
                    <Text style={styles.tableCell}>
                      {ord.Amount
                        ? ord.Amount?.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })
                        : "0.00"}
                    </Text>
                    <Text style={styles.tableCell}>
                      {ord.VATAmount
                        ? ord.VATAmount?.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })
                        : "0.00"}
                    </Text>
                    <Text style={[styles.tableCell, { borderRightWidth: 0 }]}>
                      {ord.TotalAmount
                        ? ord.TotalAmount?.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })
                        : "0.00"}
                    </Text>
                  </View>
                );
              })}
              <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text
                  style={[styles.tableCellWOBorder, { fontSize: 10, fontWeight: "bold" }]}>
                  Total
                </Text>

                <Text
                  style={[styles.tableCellWOBorder,
                  {
                    fontSize: 10,
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }]
                  }
                >
                  {totalAmount?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Text>
              </View>
            </View>
          </>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )}

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
  const MyGeneralDocumentWithGroup = (props) => (

    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        {!(Object.entries(props?.DataList) === undefined) &&
          !(Object.entries(props?.DataList) === null) &&
          Object.entries(props?.DataList)?.length > 0 ? (
          <>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>
            <View style={[styles.header, { backgroundColor: "lightgray" }]}>
              <Text>{tableHeader}</Text>{" "}
            </View>
            <View style={styles.tableFilter}>
              <Text style={styles.tableCellWOBorder}>Filter</Text>
              <Text style={styles.tableCellWOBorder}>Start Date: {startDate}</Text>
              <Text style={styles.tableCellWOBorder}>End Date: {endDate}</Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}>
                Print Date :{format(new Date(), "yyyy-MM-dd")}{" "}
              </Text>
            </View>



            {Object.entries(props?.DataList)?.map(([{ groupBy }, items]) => {
              subTotal = 0;
              return (

                <View style={styles.table}>
                  <View
                    style={[
                      styles.tableRow,
                      {
                        backgroundColor: "lightgray",
                        fontWeight: "bold",
                        fontSize: "20",
                      },
                    ]}
                  >
                    <Text style={[styles.tableCell, { marginLeft: 5, borderLeftWidth: 0 }]}>
                      Order Id
                    </Text>
                    <Text style={styles.tableCell}>Order Date</Text>
                    <Text style={styles.tableCell}>{tableHeader?.includes("Sales") ? "Customer" : "Supplier"}</Text>
                    <Text style={styles.tableCell}>Amount</Text>
                    <Text style={styles.tableCell}>VAT Amount</Text>
                    <Text style={[styles.tableCell, { borderRightWidth: 0 }]}>Total Amount</Text>
                  </View>

                  {(Array.isArray(items) ? items : Object.entries(items))?.map((ord, index) => {
                    index === 0 ? subTotal = parseFloat((ord.Amount?.replace(",", ""))) : subTotal = parseFloat(subTotal) + parseFloat((ord.Amount?.replace(",", "")));
                    groupName = (tableHeader?.includes("Sales") ? ord?.CustomerName : ord?.SupplierName);
                    return (
                      <View style={styles.tableRow}>
                        <Text style={[styles.tableCell, { marginLeft: 5, borderLeftWidth: 0 }]}>
                          {ord.OrderId}
                        </Text>
                        <Text style={styles.tableCell}>{ord.VoucherDate}</Text>
                        <Text style={styles.tableCell}>{tableHeader?.includes("Sales") ? ord.CustomerName : ord.SupplierName}</Text>
                        <Text style={styles.tableCell}>
                          {ord.Amount
                            ? ord.Amount?.toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                            })
                            : "0.00"}
                        </Text>
                        <Text style={styles.tableCell}>
                          {ord.VATAmount
                            ? ord.VATAmount?.toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                            })
                            : "0.00"}
                        </Text>
                        <Text style={[styles.tableCell, { borderRightWidth: 0 }]}>
                          {ord.TotalAmount
                            ? ord.TotalAmount?.toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                            })
                            : "0.00"}
                        </Text>
                      </View>
                    );
                  })}

                  <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
                    <Text style={{ ...styles.tableCellWOBorder, flex: 1 }}>
                      {groupName}
                    </Text>

                    <Text style={styles.tableCellWOBorder}> </Text>
                    <Text
                      style={[styles.tableCellWOBorder, { fontSize: 10, fontWeight: "bold" }]}>
                      Total
                    </Text>

                    <Text
                      style={[styles.tableCellWOBorder,
                      {
                        fontSize: 10,
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }]
                      }
                    >
                      {subTotal?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Text>
                  </View>
                </View>


              )
            }
            )
            }
            {/* --- GRAND TOTAL SECTION --- */}
            <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
              <Text style={{ ...styles.tableCellWOBorder, flex: 1 }}>Grand Total :</Text>
              <Text style={[styles.tableCellWOBorder,
              {
                fontSize: 10,
                fontWeight: "bold",
                textDecoration: "underline",
              }]
              }>{totalAmount
                ? totalAmount?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : "0.00"}</Text>
            </View>
          </>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )}

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
  const MyDetailDocument = (props) => (
    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        {!(props.Orders === undefined) &&
          !(props.Orders === null) &&
          props.Orders.length > 0 ? (
          <>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>
            <View style={[styles.header, { backgroundColor: "lightgray" }]}>
              <Text>{tableHeader}</Text>{" "}
            </View>
            <View style={styles.tableFilter}>
              <Text style={styles.tableCellWOBorder}>Filter</Text>
              <Text style={styles.tableCellWOBorder}>Start Date: {startDate}</Text>
              <Text style={styles.tableCellWOBorder}>End Date: {endDate}</Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}>
                {" "}
                Print Date :{format(new Date(), "yyyy-MM-dd")}{" "}
              </Text>
            </View>
            <View style={styles.table}>
              {props.Orders.map((ord, index) => {
                return (
                  <>
                    <View
                      style={[
                        styles.tableRow,
                        { backgroundColor: "lightgray" },
                      ]}
                    >
                      <Text style={styles.orderHeader}>
                        {"Order Id: " +
                          ord.OrderId +
                          "  Order Date: " +
                          ord.VoucherDate +
                          (tableHeader?.includes("Sales") ? "   Customer: " : "   Supplier: ") +
                          (tableHeader?.includes("Sales") ? ord?.CustomerName : ord?.SupplierName)}
                      </Text>
                    </View>
                    <View
                      style={[
                        styles.tableRow,
                        {
                          backgroundColor: "lightgray",
                          fontWeight: "bold",
                          fontSize: "20",
                        },
                      ]}
                    >
                      <Text
                        style={[styles.tableCellDetail, { paddingLeft: 3 }]}
                      >
                        Item
                      </Text>
                      <Text style={styles.tableCell}>Item Name</Text>
                      <Text style={styles.tableCell}>UOM</Text>
                      <Text style={styles.tableCell}>Quantity</Text>
                      <Text style={styles.tableCell}>Unit Price</Text>
                      <Text style={styles.tableCellWOBorder}>Total Price</Text>
                    </View>
                    {props.LineItems.filter(
                      (it) => parseInt(it.Reference) === parseInt(ord.OrderId)
                    ).map((lItem, index) => {
                      return (
                        <View style={styles.tableRow}>
                          <Text
                            style={[styles.tableCellDetail, { paddingLeft: 3 }]}
                          >
                            {lItem.Item}
                          </Text>
                          <Text style={styles.tableCell}>{lItem.Name}</Text>
                          <Text style={styles.tableCell}>{lItem.UOM}</Text>
                          <Text style={styles.tableCell}>
                            {lItem.Quantity
                              ? lItem.Quantity?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCell}>
                            {lItem.UnitPrice
                              ? lItem.UnitPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCellWOBorder}>
                            {lItem.TotalPrice
                              ? lItem.TotalPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                              : "0.00"}
                          </Text>
                        </View>
                      );
                    })}
                    <View
                      style={[
                        styles.tableRow,
                        { fontWeight: "bold", fontSize: "20" },
                      ]}
                    >
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellDetailTotals}>
                        Sub Total
                      </Text>
                      <Text style={[styles.tableCellTotals]}>
                        {ord.Amount}
                      </Text>
                    </View>
                    <View
                      style={[
                        styles.tableRow,
                        { fontWeight: "bold", fontSize: "20", border: 0 },
                      ]}
                    >
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellDetailTotals}>
                        VAT Amount
                      </Text>
                      <Text style={styles.tableCellTotals}>
                        {ord.VATAmount}
                      </Text>
                    </View>
                    <View
                      style={[
                        styles.tableRow,
                        { fontWeight: "bold", fontSize: "20", border: 0 },
                      ]}
                    >
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellWOBorder}></Text>
                      <Text style={styles.tableCellDetailTotals}>
                        Total Amount
                      </Text>
                      <Text style={styles.tableCellTotals}>
                        {ord.TotalAmount}
                      </Text>
                    </View>
                  </>
                );
              })}
              <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text style={styles.tableCellWOBorder}> </Text>
                <Text
                  style={[
                    styles.tableCell,
                    { fontSize: 10, fontWeight: "bold" },
                  ]}
                >
                  Grand Total
                </Text>

                <Text
                  style={[
                    styles.tableCellTotals,
                    {
                      fontSize: 10,
                      fontWeight: "bold",
                      textDecoration: "underline",
                    },
                  ]}
                >
                  {totalAmount?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Text>
              </View>
            </View>
          </>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
  const MyDetailDocumentWithGroup = (props) => (
    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        {!(Object.entries(props.Orders) === undefined) &&
          !(Object.entries(props.Orders) === null) &&
          Object.entries(props.Orders)?.length > 0 ? (
          <>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>
            <View style={[styles.header, { backgroundColor: "lightgray" }]}>
              <Text>{tableHeader}</Text>{" "}
            </View>
            <View style={styles.tableFilter}>
              <Text style={styles.tableCellWOBorder}>Filter</Text>
              <Text style={styles.tableCellWOBorder}>Start Date: {startDate}</Text>
              <Text style={styles.tableCellWOBorder}>End Date: {endDate}</Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}>
                {" "}
                Print Date :{format(new Date(), "yyyy-MM-dd")}{" "}
              </Text>
            </View>
            {Object.entries(props?.Orders)?.map(([{ groupBy }, items]) => {
              subTotal = 0;
              return (
                <>
                  <View style={styles.table}>
                    {(Array.isArray(items) ? items : Object.entries(items))?.map((ord, index) => {
                      index === 0 ? subTotal = parseFloat((ord.Amount?.replace(",", ""))) : subTotal = parseFloat(subTotal) + parseFloat((ord.Amount?.replace(",", "")));
                      groupName = (tableHeader?.includes("Sales") ? ord?.CustomerName : ord?.SupplierName);
                      return (
                        <>
                          <View
                            style={[
                              styles.tableRow,
                              { backgroundColor: "lightgray" },
                            ]}
                          >
                            <Text style={styles.orderHeader}>
                              {"Order Id: " +
                                ord?.OrderId +
                                "  Order Date: " +
                                ord?.VoucherDate +
                                (tableHeader?.includes("Sales") ? "   Customer: " : "   Supplier: ") +
                                (tableHeader?.includes("Sales") ? ord.CustomerName : ord?.SupplierName)}
                            </Text>
                          </View>
                          <View
                            style={[
                              styles.tableRow,
                              {
                                backgroundColor: "lightgray",
                                fontWeight: "bold",
                                fontSize: "20",
                              },
                            ]}
                          >
                            <Text
                              style={[styles.tableCellDetail, { paddingLeft: 3 }]}
                            >
                              Item
                            </Text>
                            <Text style={styles.tableCell}>Item Name</Text>
                            <Text style={styles.tableCell}>UOM</Text>
                            <Text style={styles.tableCell}>Quantity</Text>
                            <Text style={styles.tableCell}>Unit Price</Text>
                            <Text style={styles.tableCellWOBorder}>Total Price</Text>
                          </View>
                          {(Array.isArray(items) ? items : Object.entries(items))?.map((lItem, index) => {
                            groupName = lItem?.Name;
                            return (
                              <View style={styles.tableRow}>
                                <Text
                                  style={[styles.tableCellDetail, { paddingLeft: 3 }]}
                                >
                                  {lItem.Item}
                                </Text>
                                <Text style={styles.tableCell}>{lItem?.Name}</Text>
                                <Text style={styles.tableCell}>{lItem?.UOM}</Text>
                                <Text style={styles.tableCell}>
                                  {lItem?.Quantity
                                    ? lItem?.Quantity?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    : "0.00"}
                                </Text>
                                <Text style={styles.tableCell}>
                                  {lItem?.UnitPrice
                                    ? lItem?.UnitPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    : "0.00"}
                                </Text>
                                <Text style={styles.tableCellWOBorder}>
                                  {lItem?.TotalPrice
                                    ? lItem?.TotalPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    : "0.00"}
                                </Text>
                              </View>
                            )
                          })}
                          <View
                            style={[
                              styles.tableRow,
                              { fontWeight: "bold", fontSize: "20" },
                            ]}
                          >
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellDetailTotals}>
                              Sub Total
                            </Text>
                            <Text style={[styles.tableCellTotals]}>
                              //{ord.Amount}
                            </Text>
                          </View>
                          <View
                            style={[
                              styles.tableRow,
                              { fontWeight: "bold", fontSize: "20", border: 0 },
                            ]}
                          >
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellDetailTotals}>
                              VAT Amount
                            </Text>
                            <Text style={styles.tableCellTotals}>
                              {ord.VATAmount}
                            </Text>
                          </View>
                          <View
                            style={[
                              styles.tableRow,
                              { fontWeight: "bold", fontSize: "20", border: 0 },
                            ]}
                          >
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellWOBorder}></Text>
                            <Text style={styles.tableCellDetailTotals}>
                              Total Amount
                            </Text>
                            <Text style={styles.tableCellTotals}>
                              {ord.TotalAmount}
                            </Text>
                          </View>
                        </>
                      );

                    })}
                    <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
                      <Text style={
                        styles.tableRow
                      }>
                        {groupName}
                      </Text>

                      <Text style={styles.tableCellWOBorder}> </Text>
                      <Text
                        style={
                          styles.tableRow}
                      >
                        Total
                      </Text>

                      <Text
                        style={[styles.tableRow,
                        {
                          fontSize: 10,
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }]
                        }
                      >
                        {subTotal?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>



                  </View>

                </>
              );
            })}
            <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text style={styles.tableCellWOBorder}> </Text>
              <Text
                style={[
                  styles.tableCell,
                  { fontSize: 10, fontWeight: "bold" },
                ]}
              >
                Grand Total
              </Text>

              <Text
                style={[
                  styles.tableCellTotals,
                  {
                    fontSize: 10,
                    fontWeight: "bold",
                    textDecoration: "underline",
                  },
                ]}
              >
                {totalAmount?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Text>
            </View>
          </>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )
        }
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
  const MyLineItemsDocument = () => (
    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text>Text</Text>
        </View>
        <View style={styles.header}>
          {globalUser.PaperHeader && (
            <Image style={styles.logo} src={globalUser.PaperHeader} />
          )}
        </View>
        <View style={[styles.header, { backgroundColor: "gray" }]}>
          <Text>{tableHeader}</Text>{" "}
        </View>
        <View style={styles.tableFilter}>
          <Text style={styles.tableCellWOBorder}>Filter</Text>
          <Text style={styles.tableCellWOBorder}>Start Date: {startDate}</Text>
          <Text style={styles.tableCellWOBorder}>End Date: {endDate}</Text>

          <Text style={styles.tableCellWOBorder}>Item </Text>
          <Text style={styles.tableCellWOBorder}>
            {allItems.filter((it) => parseInt(it.Item) === parseInt(item))
              .length > 0
              ? allItems.filter((it) => parseInt(it.Item) === parseInt(item))[0]
                .Name
              : ""}{" "}
          </Text>
          <Text style={styles.tableCellWOBorder}>
            Print Date :{format(new Date(), "yyyy-MM-dd")}{" "}
          </Text>
        </View>
        <View style={styles.table}>
          <View
            style={[
              styles.tableRow,
              {
                backgroundColor: theme.palette.primary.main,
                fontWeight: "bold",
                fontSize: "20",
              },
            ]}
          >
            <Text style={styles.tableCell}>Item</Text>
            <Text style={styles.tableCell}>Item Name</Text>
            <Text style={styles.tableCell}>Posting Date</Text>
            <Text style={styles.tableCell}>Type</Text>
            <Text style={styles.tableCell}>Quantity</Text>
            <Text style={styles.tableCell}>Unit Price</Text>
            <Text style={styles.tableCell}>Total Price</Text>
            <Text style={styles.tableCell}>Unit Cost</Text>
            <Text style={styles.tableCell}>Inventory</Text>
            <Text style={styles.tableCell}>Reference</Text>
          </View>
          {(Array.isArray(dataList) ? dataList : Object.entries(dataList))?.map((lItem, index) => {
            return (
              <View style={[
                styles.tableRow,
                {
                  fontWeight: "bold",
                  fontSize: "20",
                },
              ]}>
                <Text style={styles.tableCell}>{lItem.Item}</Text>
                <Text style={styles.tableCell}>{lItem.Name}</Text>
                <Text style={styles.tableCell}>{lItem.VoucherDate}</Text>
                <Text style={styles.tableCell}>{lItem.Status}</Text>
                <Text style={styles.tableCell}>
                  {lItem.Quantity
                    ? lItem.Quantity?.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </Text>
                <Text style={styles.tableCell}>
                  {lItem.UnitPrice
                    ? lItem.UnitPrice?.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </Text>
                <Text style={styles.tableCell}>
                  {lItem.TotalPrice
                    ? lItem.TotalPrice?.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </Text>
                <Text style={styles.tableCell}>
                  {lItem.CalculatedCost
                    ? lItem.CalculatedCost?.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </Text>
                <Text style={styles.tableCell}>
                  {lItem.Balance
                    ? lItem.Balance?.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </Text>
                <Text style={styles.tableCell}>{lItem.OrderId}</Text>
              </View>
            );
          })}

          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              "Page: " + `${pageNumber} / ${totalPages}`
            }
            fixed
          />
        </View>
      </Page>
    </Document>
  );
  const MyLineItemsDocumentWithGroup = (props) => (
    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        {!(props?.DataList === undefined) &&
          !(props?.DataList === null) &&
          Object.entries(props?.DataList)?.length > 0 ? (
          <>
            <View style={styles.header}>
              <Text>Text</Text>
            </View>
            <View style={styles.header}>
              {globalUser.PaperHeader && (
                <Image style={styles.logo} src={globalUser.PaperHeader} />
              )}
            </View>
            <View style={[styles.header, { backgroundColor: "gray" }]}>
              <Text>{tableHeader}</Text>{" "}
            </View>
            <View style={styles.tableFilter}>
              <Text style={styles.tableCellWOBorder}>Filter</Text>
              <Text style={styles.tableCellWOBorder}>Start Date: {startDate}</Text>
              <Text style={styles.tableCellWOBorder}>End Date: {endDate}</Text>

              <Text style={styles.tableCellWOBorder}>Item </Text>
              <Text style={styles.tableCellWOBorder}>
                {allItems.filter((it) => parseInt(it.Item) === parseInt(item))
                  .length > 0
                  ? allItems.filter((it) => parseInt(it.Item) === parseInt(item))[0]
                    .Name
                  : ""}{" "}
              </Text>
              <Text style={styles.tableCellWOBorder}>
                Print Date :{format(new Date(), "yyyy-MM-dd")}{" "}
              </Text>
            </View>
            <View style={styles.table}>
              {Object.entries(props?.DataList)?.map(([{ groupBy }, items]) => {
                subTotal = 0;
                return (
                  <>
                    <View
                      style={[
                        styles.tableRow,
                        {
                          backgroundColor: "lightgray",
                          fontWeight: "bold",
                          fontSize: "20",
                          marginBottom: -3
                        },
                      ]}
                    >
                      <Text style={styles.tableCell}>Item</Text>
                      <Text style={styles.tableCell}>Item Name</Text>
                      <Text style={styles.tableCell}>Posting Date</Text>
                      <Text style={styles.tableCell}>Type</Text>
                      <Text style={styles.tableCell}>Quantity</Text>
                      <Text style={styles.tableCell}>Unit Price</Text>
                      <Text style={styles.tableCell}>Total Price</Text>
                      <Text style={styles.tableCell}>Unit Cost</Text>
                      <Text style={styles.tableCell}>Inventory</Text>
                      <Text style={styles.tableCell}>Reference</Text>
                    </View>
                    {(Array.isArray(items) ? items : Object.entries(items))?.map((lItem, index) => {
                      subTotal = parseFloat(subTotal) + parseFloat(lItem.Quantity);
                      groupName = lItem.VoucherDate;
                      return (
                        <View style={[
                          styles.tableRow,
                          {
                            fontWeight: "bold",
                            fontSize: "20",
                          },
                        ]}>
                          <Text style={styles.tableCell}>{lItem.Item}</Text>
                          <Text style={styles.tableCell}>{lItem.Name}</Text>
                          <Text style={styles.tableCell}>{lItem.VoucherDate}</Text>
                          <Text style={styles.tableCell}>{lItem.Status}</Text>
                          <Text style={styles.tableCell}>
                            {lItem.Quantity
                              ? lItem.Quantity?.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCell}>
                            {lItem.UnitPrice
                              ? lItem.UnitPrice?.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCell}>
                            {lItem.TotalPrice
                              ? lItem.TotalPrice?.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCell}>
                            {lItem.CalculatedCost
                              ? lItem.CalculatedCost?.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCell}>
                            {lItem.Balance
                              ? lItem.Balance?.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                              })
                              : "0.00"}
                          </Text>
                          <Text style={styles.tableCell}>{lItem.OrderId}</Text>
                        </View>
                      )
                    })}
                    <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
                      <Text style={{ ...styles.tableCellWOBorder, flex: 1 }}>
                        {groupName}
                      </Text>

                      <Text style={styles.tableCellWOBorder}> </Text>
                      <Text
                        style={[styles.tableCellWOBorder, { fontSize: 10, fontWeight: "bold" }]}>
                        Total Quantity:
                      </Text>

                      <Text
                        style={[styles.tableCellWOBorder,
                        {
                          fontSize: 10,
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }]
                        }
                      >
                        {subTotal?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>


                  </>
                )
              }
              )}
              <Text
                style={styles.pageNumber}
                render={({ pageNumber, totalPages }) =>
                  "Page: " + `${pageNumber} / ${totalPages}`
                }
                fixed
              />
            </View>
          </>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>)
        }

      </Page>
    </Document>
  );
  const MyAdministratorDocument = (props) => (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {!(props.DataList === undefined) &&
          !(props.DataList === null) &&
          props.DataList?.length > 0 ? (
          <View style={{ flex: 1 }}>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>
            <View style={[styles.header, { backgroundColor: "gray", color: 'white' }]}>
              <Text>{tableHeader}</Text>{" "}
            </View>
            <View style={styles.table}>
              <View
                style={[
                  styles.tableRow,
                  {
                    backgroundColor: "gray",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "20",
                  },
                ]}
              >
                <Text style={styles.tableCell}>Id</Text>
                <Text style={[styles.tableCell, { width: '35%' }]}>Name</Text>
                {!tableHeader.includes("s' Balance") && <Text style={[styles.tableCell, { width: '25%' }]}>{tableHeader.includes("Stock") ? "Store" : "User Name"}</Text>}
                <Text style={[styles.tableCell, { width: '25%' }]}>{tableHeader.includes("Stock") ? "Inventory" : "Balance"}</Text>
              </View>
              {props.DataList?.map((item, index) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>{item.Id}</Text>
                    <Text style={[styles.tableCell, { width: '35%' }]}>{item.Name}</Text>
                    {!tableHeader.includes("s' Balance") && <Text style={[styles.tableCell, { width: '25%' }]}>{item.StoreName}</Text>}
                    <Text style={[styles.tableCell, { width: '25%' }]}>{tableHeader.includes("s' Balance") ? item.Balance : item.Quantity}</Text>
                  </View>
                );
              })}


            </View>

            <Text
              fixed
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
                `${pageNumber} / ${totalPages}`
              }
            />


          </View>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader?.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )}
      </Page>
    </Document>
  );
  const MyAdministratorDocumentWithGroup = (props) => (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {!(Object.values(props.DataList) === undefined) &&
          !(Object.values(props.DataList) === null) &&
          Object.values(props.DataList)?.length > 0 ? (
          <View style={{ flex: 1 }}>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>
            <View style={[styles.header, { backgroundColor: "gray", color: 'white' }]}>
              <Text>{tableHeader}kkkkk</Text>{" "}
            </View>

            {Object.entries(props?.DataList)?.map(([{ groupBy }, items]) => {
              console.log('groupBy', groupBy)
              subTotal = 0;
              return (

                <View style={styles.table}>
                  <View
                    style={[
                      styles.tableRow,
                      {
                        backgroundColor: "gray",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "20",
                      },
                    ]}
                  >
                    <Text style={styles.tableCell}>Id</Text>
                    <Text style={[styles.tableCell, { width: '35%' }]}>Name</Text>
                    <Text style={[styles.tableCell, { width: '25%' }]}>{tableHeader.includes("Stock") ? "Store" : "User Name"}</Text>
                    <Text style={[styles.tableCell, { width: '25%' }]}>{tableHeader.includes("Stock") ? "Inventory" : "Balance"}</Text>
                  </View>


                  {(Array.isArray(items) ? items : Object.entries(items))?.map((ord, index) => {
                    subTotal = parseFloat(subTotal) + parseFloat((ord.Quantity ? ord.Quantity : 0))
                    groupName = ord.Name;
                    return (
                      <View style={styles.tableRow}>
                        <Text style={styles.tableCell}>{item.Item}</Text>
                        <Text style={[styles.tableCell, { width: '35%' }]}>{ord.Name}</Text>
                        <Text style={[styles.tableCell, { width: '25%' }]}>{ord.StoreName}</Text>
                        <Text style={[styles.tableCell, { width: '25%' }]}>{(ord.Quantity ? ord.Quantity : 0)}</Text>
                      </View>
                    )
                  })}
                  <View style={[styles.tableRow, { backgroundColor: "lightgray" }]}>
                    <Text style={{ ...styles.tableCellWOBorder, flex: 1 }}>
                      {groupName}
                    </Text>

                    <Text style={styles.tableCellWOBorder}> </Text>
                    <Text
                      style={[styles.tableCellWOBorder, { fontSize: 10, fontWeight: "bold" }]}>
                      Total
                    </Text>

                    <Text
                      style={[styles.tableCellWOBorder,
                      {
                        fontSize: 10,
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }]
                      }
                    >
                      {subTotal?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Text>
                  </View>
                </View>
              )
            })}



            <Text
              fixed
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
                `${pageNumber} / ${totalPages}`
              }
            />


          </View>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader?.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )}
      </Page>
    </Document>
  );
  const MyAdministratorDetailDocument = (props) => (
    <Document rotate={90}>
      <Page size="A4" style={styles.page}>
        {!(props.DataList === undefined) &&
          !(props.DataList === null) &&
          props.DataList?.length > 0 ? (
          <>
            <View style={styles.header}>
              <Image style={styles.logo} src={globalUser.PaperHeader} />
            </View>

            <View style={styles.table}>
              <View
                style={[
                  styles.tableRow,
                  {
                    backgroundColor: "gray",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "20",
                  },
                ]}
              >
                {" "}
                <Text style={styles.tableCell}>Id</Text>
                <Text style={styles.tableCell}>Id</Text>
                <Text style={styles.tableCell}>Name</Text>
                <Text style={styles.tableCell}>User Name</Text>
              </View>
              {props.DataList?.map((item, index) => {
                return (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>{item.Id}</Text>
                    <Text style={styles.tableCell}>{item.Name}</Text>
                    <Text style={styles.tableCell}>{item.UserName}</Text>
                  </View>
                );
              })}
              <View
                style={[
                  styles.tableRow,
                  { backgroundColor: "gray", color: "white" },
                ]}
              >
                <Text style={styles.tableCell}> </Text>
                <Text style={styles.tableCell}> </Text>
                <Text style={styles.tableCell}> </Text>
                <Text style={styles.tableCell}> </Text>
                <Text
                  style={[
                    styles.tableCell,
                    { fontSize: 10, fontWeight: "bold" },
                  ]}
                >
                  Total
                </Text>

                <Text
                  style={[
                    styles.tableCell,
                    {
                      fontSize: 10,
                      fontWeight: "bold",
                      textDecoration: "underline",
                    },
                  ]}
                >
                  {totalAmount?.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                  })}
                </Text>
              </View>

              <Text
                style={styles.pageNumber}
                render={({ pageNumber, totalPages }) =>
                  "Designed By EthioB2B Mobile: 251-913-4040-58   Email: ArmaItSolution@gmail.com         Page: " +
                  `${pageNumber} / ${totalPages}`
                }
                fixed
              />
            </View>
          </>
        ) : (
          <View style={styles.header}>
            <Text>
              {tableHeader?.length > 0
                ? "There is no data for " +
                tableHeader +
                " between " +
                startDate +
                " and " +
                endDate
                : "Select the order type in the left"}
            </Text>{" "}
          </View>
        )}
      </Page>
    </Document>
  );

  const [dataList, setDataList] = useState([]);
  const [lineItemsList, setLineItemsList] = useState([]);
  const [reportType, setReportType] = useState("General");
  const loadVouchersList = (type, status) => {
    var tempTotal = 0;
    setDataList([]);
    axios
      .get(
        "/Vouchers/getReportByDateAndType?Parent=" +
        globalUser.Parent +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&Status=" +
        status +
        "&Type=" +
        type,
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {

        if (response.data.data) {
          // Grouping by the 'SupplierName' field
          if (groupReport) {
            const groupedData = response.data.data.reduce((acc, item) => {
              const key = (type === "Sales" ? item.CustomerName : item.SupplierName) || "Unknown Supplier";
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            setDataList(groupedData)

          } else {
            setDataList(response.data.data);
          }
          response.data.data.map((ord, index) => {
            tempTotal =
              parseFloat(tempTotal) +
              parseFloat(ord.TotalAmount.toLocaleString().replaceAll(",", ""));
          });
          setTotalAmount(tempTotal);
        } else {
          alert("log out and log in again");
        }
      });
  };
  const loadSupplierBalance = (type) => {
    var tempTotal = 0;
    setDataList([]);
    axios
      .get(
        "/Vouchers/getSupplierBalance?Parent=" +
        globalUser.Parent +
        "&Type=" +
        type,
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {

        if (response.data.data) {
          // Grouping by the 'SupplierName' field
          if (groupReport) {
            const groupedData = response.data.data.reduce((acc, item) => {
              const key = (type === "Sales" ? item.CustomerName : item.SupplierName) || "Unknown Supplier";
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            setDataList(groupedData)

          } else {
            setDataList(response.data.data);
          }
          response.data.data.map((ord, index) => {
            tempTotal =
              parseFloat(tempTotal) +
              parseFloat(ord?.TotalAmount?.toLocaleString().replaceAll(",", ""));
          });
          setTotalAmount(tempTotal);
        } else {
          alert("log out and log in again");
        }
      });
  };
  const loadPaymentList = (type) => {
    var tempTotal = 0;
    setDataList([]);
    axios.get("/payments/getByParentAndModule?Parent=" + globalUser.Parent + "&Module=" + type +
      "&StartDate=" + startDate +
      "&EndDate=" + endDate,
      {
        headers: {
          token: globalToken,
        },
      })
      .then(response => {

        if (response.data.data) {
          // Grouping by the 'SupplierName' field
          if (groupReport) {
            const groupedData = response.data.data.reduce((acc, item) => {
              const key = (type === "Sales" ? item.CustomerName : item.SupplierName) || "Unknown Supplier";
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            setDataList(groupedData)

          } else {
            setDataList(response.data.data);
          }

          response.data.data.map((ord, index) => {
            tempTotal =
              parseFloat(tempTotal) +
              parseFloat(ord.Amount.toLocaleString().replaceAll(",", ""));
          });
          setTotalAmount(tempTotal);
        } else {
          alert('log out and log in again22')
        }
      })

  };
  /*  const loadLineItemsList = (type, status) => {
     setDataList([]);
     axios
       .get(
         "/lineitems/getReportByDate?Parent=" +
           globalUser.Parent +
           "&StartDate=" +
           startDate +
           "&EndDate=" +
           endDate +
           "&Status=" +
           status +
           "&Type=" +
           type,
         {
           headers: {
             token: globalToken,
           },
         }
       )
       .then((response) => {
         if (response.data.data) {
           setLineItemsList(response.data.data);
           //setLineItemsList(response.data.data.LineItems);
         } else {
           alert("log out and log in again");
         }
       });
   }; */

  const loadDetailVouchersList = (type, status) => {
    setDataList([]);
    var tempTotal = 0;
    axios
      .get(
        "/Vouchers/getDetailReportByDateAndType?Parent=" +
        globalUser.Parent +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&Status=" +
        status +
        "&Type=" +
        type,
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {
        if (response.data.data) {
          if (groupReport) {
            const groupedData = response.data.data.Orders.reduce((acc, item) => {
              const key = (type === "Sales" ? item.CustomerName : item.SupplierName) || "Unknown Supplier";
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            setDataList(groupedData)

          } else {
            setDataList(response.data.data.Orders);
          }


          setLineItemsList(response.data.data.LineItems);
          response.data.data.Orders.map((ord, index) => {
            tempTotal =
              parseFloat(tempTotal) +
              parseFloat(ord.TotalAmount.toLocaleString().replaceAll(",", ""));
          });
          setTotalAmount(tempTotal);
        } else {
          alert("log out and log in again");
        }
      });
  };
  const loadLineItemsList = () => {

    axios
      .get(
        "/lineItems/getItemLedger?Parent=" +
        globalUser.Parent +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&Store=0" +
        "&Item=" + (allItems.filter((it) => it.Name == item).length > 0
          ? allItems.filter((it) => it.Name == item)[0]
            .Item
          : 0),
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        } else {
          alert("log out and log in again");
        }
      });
  };

  const loadDetailItemHistory = (item) => {
    setDataList([]);
    axios
      .get(
        "/items/getItemHistory?Item=" +
        item +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate +
        "&Parent=" +
        globalUser.Parent,
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        }
      });
  };
  const loadCustomersList = (type) => {
    setDataList([]);
    axios
      .get(
        "/suppliers/getByParentAndType?Parent=" +
        globalUser.Parent +
        "&Type=" +
        type,
        {
          headers: {
            token: globalToken,
          },
        }
      )
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        }
      });
  };
  const loadEmployeesList = () => {
    setDataList([]);
    axios
      .get("/employees/getByParent?Parent=" + globalUser.Parent, {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        }
      });
  };
  const loadItemsList = () => {
    setDataList([]);
    axios
      .get("/items", {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        }
      });
  };
  const loadItemCategoriesList = () => {
    setDataList([]);
    axios
      .get("/itemCategories", {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        }
      });
  };
  const loadStoresList = () => {
    setDataList([]);
    axios
      .get("/stores/getByParent?Parent=" + globalUser.Parent, {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          setDataList(response.data.data);
        }
      });
  };
  const loadStockBalancesList = () => {
    setDataList([]);
    axios
      .get("/stockbalances/getByParent?Parent=" + globalUser.Parent +"&Item="+item, {
        headers: {
          token: globalToken,
        },
      })
      .then((response) => {
        if (response.data.data) {
          console.log('Stockbalancelist', response.data.data)
          if (groupReport) {
            const groupedData = response.data.data.reduce((acc, item) => {
              const key = item.Name || "Unknown"
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            setDataList(groupedData)

          } else {
            setDataList(response.data.data);
          }
        }
      });
  };
  const loadPurchasedOrSoldItems = (type) => {
    setDataList([]);
    axios
      .get("/lineitems/getItemPurchasedOrSold?Type=" + type +
        "&Parent=" + globalUser.Parent +
        "&StartDate=" +
        startDate +
        "&EndDate=" +
        endDate,
        {
          headers: {
            token: globalToken,
          },
        })
      .then((response) => {
        if (response.data.data) {
          console.log('purchaseorSolditems', response.data.data)
          if (groupReport) {
            const groupedData = response.data.data.reduce((acc, item) => {
              const key = item.VoucherDate || "Unknown"
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            setDataList(groupedData)

          } else {
            setDataList(response.data.data);
          }
        }
      });
  };
  useEffect(() => {
    if (!globalUser) {
      navigate('/');
      return;
    }
    setPageHeader("Reports");
    if (tableHeader === "Purchase Orders List") {
      loadVouchersList("Purchase", "Order");
    } else if (tableHeader === "Purchase Requests List") {
      loadVouchersList("Purchase", "Request");
    } else if (tableHeader === "Purchase Received Orders List") {
      loadVouchersList("Purchase", "Received");
    } else if (tableHeader === "Purchase Return Orders List") {
      loadVouchersList("Purchase", "Return");
    } else if (tableHeader === "Purchase Archived List") {
      loadVouchersList("Purchase", "Archived");
    } else if (tableHeader === "Purchase Payment List") {
      loadPaymentList("Purchase");
    } else if (tableHeader === "Purchased Items List") {
      loadPurchasedOrSoldItems("Purchase");
    } else if (tableHeader === "Suppliers History") {
      loadDetailItemHistory(allItems.filter((it) => it.Name == item).length > 0
        ? allItems.filter((it) => it.Name == item)[0] : 0);
    } else if (tableHeader === "Suppliers List") {
      loadCustomersList("Supplier");
    } else if (tableHeader === "Employees List") {
      loadEmployeesList();
    } else if (tableHeader === "Items List") {
      loadItemsList();
    } else if (tableHeader === "Item Categories List") {
      loadItemCategoriesList();
    } else if (tableHeader === "Stores List") {
      loadStoresList();
    } else if (tableHeader === "Stock Balances List") {
      loadStockBalancesList();
    } else if (tableHeader === "Purchase Detail Report") {
      loadDetailVouchersList("Purchase", "Order");
    } else if (tableHeader === "Purchase Detail Requests Report") {
      loadDetailVouchersList("Purchase", "Request");
    } else if (tableHeader === "Purchase Detail Received Report") {
      loadDetailVouchersList("Purchase", "Received");
    } else if (tableHeader === "Purchase Detail Return Report") {
      loadDetailVouchersList("Purchase", "Return");
    } else if (tableHeader === "Purchase Detail Archived Report") {
      loadDetailVouchersList("Purchase", "Archived");
    } else if (tableHeader === "Purchase Detail Payment Report") {
      loadPaymentList("Purchase");
    } else if (tableHeader === "Purchase Detail Items Report") {
      loadDetailVouchersList("Purchase", "Items");
    } else if (tableHeader === "Suppliers History Detail Report") {
      loadDetailItemHistory(allItems.filter((it) => it.Name == item).length > 0
        ? allItems.filter((it) => it.Name == item)[0]
          .Item : 0);
    } else if (tableHeader === "Purchase Summary Report") {
      //loadSummaryVouchersList("Purchase");
    } else if (tableHeader === "Purchase Summary Detail Report") {
      //loadSummaryDetailVouchersList("Purchase");
    } else if (tableHeader === "Administrator List") {
      loadCustomersList("Administrator");
    } else if (tableHeader === "Administrator Detail Report") {
      loadCustomersList("Administrator");
    } else if (tableHeader === "Sales Quotation List") {
      loadVouchersList("Sales", "Quotation");
    } else if (tableHeader === "Sales Orders List") {
      loadVouchersList("Sales", "Order");
    } else if (tableHeader === "Sales Invoices List") {
      loadVouchersList("Sales", "Invoice");
    } else if (tableHeader === "Sales Delivery Notes List") {
      loadVouchersList("Sales", "Delivery");
    } else if (tableHeader === "Sales Return List") {
      loadVouchersList("Sales", "Return");
    } else if (tableHeader === "Sales Payment List") {
      loadPaymentList("Sales");
    } else if (tableHeader === "Sold Items List") {
      loadPurchasedOrSoldItems("Sales");
    } else if (tableHeader === "Sales Items List") {
      loadLineItemsList();
    } else if (tableHeader === "Customers List") {
      loadCustomersList("Customer");
    } else if (tableHeader === "Customers History") {
      loadDetailItemHistory(allItems.filter((it) => it.Name == item).length > 0
        ? allItems.filter((it) => it.Name == item)[0]
          .Item : 0);
    } else if (tableHeader === "Sales Detail Quotation Report") {
      loadDetailVouchersList("Sales", "Quotation");
    } else if (tableHeader === "Sales Detail Orders Report") {
      loadDetailVouchersList("Sales", "Order");
    } else if (tableHeader === "Sales Detail Invoices Report") {
      loadDetailVouchersList("Sales", "Invoice");
    } else if (tableHeader === "Sales Detail Delivery Notes Report") {
      loadDetailVouchersList("Sales", "Delivery");
    } else if (tableHeader === "Sales Detail Return Report") {
      loadDetailVouchersList("Sales", "Return");
    } else if (tableHeader === "Sales Detail Payment Report") {
      loadPaymentList("Sales");
    } else if (tableHeader === "Sales Detail Items Report") {
      loadDetailVouchersList("Sales", "Items");
    } else if (tableHeader === "Sales Summary Report") {
      // loadSummaryVouchersList("Sales");
    } else if (tableHeader === "Sales Summary Detail Report") {
      // loadSummaryDetailVouchersList("Sales");
    }
  }, [update, startDate, endDate, item]);
  useEffect(() => {
    if (!globalUser) {
      navigate('/');
      return;
    }
    if (groupReport) {
      const groupData = Object.values(dataList)?.reduce((acc, item) => {
        const key = (tableHeader?.includes("Purchased") ? item.VoucherDate : tableHeader?.includes("Sold") ? item.VoucherDate : tableHeader?.includes("Sales") ? item.CustomerName : tableHeader?.includes("Stock") ? item.Name : item.SupplierName) || "Unknown Supplier";
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        console.log('Acc', acc)
        return acc;
      }, {})
      setDataList(groupData)
    } else {
      setDataList(Object.values(dataList).flat());
    }
  }, [groupReport])
  return (
    <Grid
      container
      mt={1}
      sx={{
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      }}
    >
      <Grid item xs={2} border={1}>
        <Button
          variant="contained"
          fullWidth
          disabled={true}
          style={{
            fontWeight: "bold",
            color: theme.palette.primary.contrastText,
          }}
          startIcon={<AssessmentOutlined />}
        >
          Reports
        </Button>
        {globalRoleSecurity.filter(
          (sec) =>
            sec.Functionality === "Purchase Reports" && !(sec.Security === 0)
        ).length > 0 && (
            <Grid container p={0.5}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: !expandReport.State,
                      Module: "Purchase",
                      Type: "",
                      Filter: false,
                    });
                  }}
                >
                  Purchase
                </Button>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Purchase" && expandReport.State
                      ? "block"
                      : "none",
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Purchase",
                      Type: expandReport.Type === "General" ? "" : "General",
                      Filter: true,
                    });
                  }}
                >
                  General Reports
                </Button>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Purchase" &&
                      expandReport.Type === "General" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>
                  {/*    <Grid item xs={12} style={{ textAlign: "left" }}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Purchase Draft Orders List");
                      loadVouchersList("Purchase", "Draft");
                      setGroupBy("SupplierName")
setReportType("General");
                    }}
                  >
                    Purchase Draft
                  </Button>
                </Grid> */}
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"

                      onClick={() => {
                        setTableHeader("Purchase Requests List");
                        loadVouchersList("Purchase", "Request");
                        setGroupBy("SupplierName");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Purchase Requests
                    </Button>
                  </grid>

                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Purchase Orders List");
                        loadVouchersList("Purchase", "Order");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Purchase Orders
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Purchase Received Orders List");
                        loadVouchersList("Purchase", "Received");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Purchase Received
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Purchase Return Orders List");
                        loadVouchersList("Purchase", "Return");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Purchase Return
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Purchase Archived List");
                        loadVouchersList("Purchase", "Archived");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Purchase Archived
                    </Button>
                  </grid>

                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Purchase Payment List");
                        loadPaymentList("Purchase");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Purchase Payment
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Purchased Items List");
                        loadPurchasedOrSoldItems("Purchase");
                        setGroupBy("SupplierName")
                        setReportType("LineItems");
                      }}
                    >
                      Purchased Items
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Suppliers History");
                        loadVouchersList("Purchase", "Items");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Suppliers History
                    </Button>
                  </grid>

                </Grid>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Purchase" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Purchase",
                      Type: expandReport.Type === "Detail" ? "" : "Detail",
                      Filter: true,
                    });
                  }}
                >
                  Detail Reports
                </Button>
              </Grid>
              <Grid
                item
                p={1}
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Purchase" &&
                      expandReport.Type === "Detail" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>
                  {/*   <Grid item xs={12}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Detail Purchase Draft Orders List");
                      loadDetailVouchersList("Purchase", "Draft");
                      setReportType("Detail");
                    }}
                  >
                    Detail Draft
                  </Button>
                </Grid> */}
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Purchase Requests List");
                        loadDetailVouchersList("Purchase", "Request");
                        setReportType("Detail");
                        setGroupBy("SupplierName")
                      }}
                    >
                      Detail Requests
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Purchase Orders List");
                        loadDetailVouchersList("Purchase", "Order");
                        setReportType("Detail");
                        setGroupBy("SupplierName")
                      }}
                    >
                      Detail Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Purchase Received Orders List");
                        loadDetailVouchersList("Purchase", "Received");
                        setReportType("Detail");
                        setGroupBy("SupplierName")
                      }}
                    >
                      Detail Received
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Purchase Return Orders List");
                        loadDetailVouchersList("Purchase", "Return");
                        setReportType("Detail");
                      }}
                    >
                      Detail Return
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Purchase Archived List");
                        loadDetailVouchersList("Purchase", "Archived");
                        setReportType("Detail");
                        setGroupBy("SupplierName")
                      }}
                    >
                      Detail Archived
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Purchase Payment List");
                        loadPaymentList("Purchase");
                        setReportType("Detail");
                        setGroupBy("SupplierName")
                      }}
                    >
                      Detail Payment
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Purchase" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Purchase",
                      Type: expandReport.Type === "Summary" ? "" : "Summary",
                    });
                  }}
                >
                  Summary Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Purchase" &&
                      expandReport.Type === "Summary" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                {/*  <Grid container>
                  {/*        <Grid item xs={12}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Sales Draft Orders List");
                      loadVouchersList("Sales", "Draft");
                    }}
                  >
                    Summary Draft
                  </Button>
                </Grid> 
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Quotes List");
                        loadVouchersList("Sales", "Quote");
                      }}
                    >
                      Summary Requests
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Orders List");
                        loadVouchersList("Sales", "Order");
                        setGroupBy("CustomerName")
                      }}
                    >
                      Summary Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Shipped Orders List");
                        loadVouchersList("Sales", "Shipped");
                      }}
                    >
                      Summary Delivery
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Line Items List");
                        loadLineItemsList("Sales", "Shipped");
                        setReportType("LineItems");
                        setGroupBy("CustomerName")
                        setItemVisbile(true);
                      }}
                    >
                      Summary Delivery LineItems
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Payment List");
                        loadPaymentList("Sales");
                        setGroupBy("CustomerName")
                        setReportType("Summary");
                      }}
                    >
                      Summary Payment
                    </Button>
                  </Grid>
                </Grid> */}
              </Grid>
            </Grid>
          )}
        {globalRoleSecurity.filter(
          (sec) =>
            sec.Functionality === "Sales Reports" && !(sec.Security === 0)
        ).length > 0 && (
            <Grid container p={0.5}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: !expandReport.State,
                      Module: "Sales",
                      Type: "",
                      Filter: true,
                    });
                  }}
                >
                  Sales
                </Button>
              </Grid>
              <Grid
                p={0.5}
                pl={3}
                item
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Sales" && expandReport.State
                      ? "block"
                      : "none",
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Sales",
                      Type: expandReport.Type === "General" ? "" : "General",
                      Filter: true,
                    });
                  }}
                >
                  General Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Sales" &&
                      expandReport.Type === "General" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <ul>
                  {/*     <grid item xs={12} style={{ textalign: "left" }}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Sales Draft Orders List");
                      loadVouchersList("Sales", "Draft");
                      setGroupBy("SupplierName")
setReportType("General");
                    }}
                  >
                    Sales Drafts
                  </Button>
                </grid> */}
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Quote List");
                        loadVouchersList("Sales", "Quote");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Sales Quotes
                    </Button>
                  </grid>

                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Orders List");
                        loadVouchersList("Sales", "Order");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Sales Orders
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Delivery Orders List");
                        loadVouchersList("Sales", "Delivery");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Sales Delivery
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Payment List");
                        loadPaymentList("Sales");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Sales Payment
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sold Items List");
                        loadPurchasedOrSoldItems("Sales");
                        setGroupBy("CustomerName");
                        setReportType("LineItems");
                      }}
                    >
                      Soled Items
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Customers History");
                        loadVouchersList("Purchase", "Items");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Customers History
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Customers Balance");
                        loadSupplierBalance("Sales");
                        setGroupBy("Name");
                        setReportType("General");
                      }}
                    >
                      Customers Balance
                    </Button>
                  </grid>
                </ul>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Sales" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Sales",
                      Type: expandReport.Type === "Detail" ? "" : "Detail",
                      Filter: true,
                    });
                  }}
                >
                  Detail Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Sales" &&
                      expandReport.Type === "Detail" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>
                  {/*       <Grid item xs={12}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Detail Sales Draft Orders List");
                      loadDetailVouchersList("Sales", "Draft");
                      setReportType("Detail");
                    }}
                  >
                    Detail Drafts
                  </Button>
                </Grid> */}
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Sales Quotes List");
                        loadDetailVouchersList("Sales", "Quote");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Requests
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Sales Orders List");
                        loadDetailVouchersList("Sales", "Order");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Sales Delivery Orders List");
                        loadDetailVouchersList("Sales", "Delivery");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Delivery
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Sales Payment List");
                        loadPaymentList("Sales");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Payment
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Sales" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Sales",
                      Type: expandReport.Type === "Summary" ? "" : "Summary",
                      Filter: true,
                    });
                  }}
                >
                  Summary Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Sales" &&
                      expandReport.Type === "Summary" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                {/*   <Grid container>
                    <Grid item xs={12}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Sales Draft Orders List");
                      loadVouchersList("Sales", "Draft");
                    }}
                  >
                    Summary Draft
                  </Button>
                </Grid> 
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Quotes List");
                        loadVouchersList("Sales", "Quote");
                      }}
                    >
                      Summary Requests
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Orders List");
                        loadVouchersList("Sales", "Order");
                      }}
                    >
                      Summary Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Shipped Orders List");
                        loadVouchersList("Sales", "Shipped");
                      }}
                    >
                      Summary Delivery
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Line Items List");
                        loadLineItemsList("Sales", "Shipped");
                        setGroupBy("CustomerName");
                        setReportType("LineItems");
                        setItemVisbile(true);
                      }}
                    >
                      Summary Delivery LineItems
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Payment List");
                        loadPaymentList("Sales");
                      }}
                    >
                      Summary Payment
                    </Button>
                  </Grid>
                </Grid> */}
              </Grid>
            </Grid>
          )}
        {globalRoleSecurity.filter(
          (sec) =>
            sec.Functionality === "Inventory Reports" && !(sec.Security === 0)
        ).length > 0 && (
            <Grid container p={0.5}>
              <Grid item pl={2} p={0.5} xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: !expandReport.State,
                      Module: "Inventory",
                      Type: "",
                      Filter: true,
                    });
                  }}
                >
                  Inventory
                </Button>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Inventory" && expandReport.State
                      ? "block"
                      : "none",
                  textAlign: "left",
                }}
              >
                <Button
                  m={2}
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Inventory",
                      Type: expandReport.Type === "General" ? "" : "General",
                      Filter: true,
                    });
                  }}
                >
                  General Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Inventory" &&
                      expandReport.Type === "General" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <ul>
                  {/*          <grid item xs={12} style={{ textalign: "left" }}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Item Request List");
                      loadVouchersList("Inventory", "Draft");
                      setGroupBy("SupplierName")
setReportType("General");
                    }}
                  >
                    Item Request List
                  </Button>
                </grid> */}
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Item Requests Approval List");
                        loadVouchersList("Inventory", "Request");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Item Requests Approval List
                    </Button>
                  </grid>

                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Item Issues List");
                        loadVouchersList("Inventory", "Order");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Item Issues List
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Item Received List");
                        loadVouchersList("Inventory", "Received");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Item Received List
                    </Button>
                  </grid>

                  {/*   <grid item xs={12} style={{ textalign: "left" }}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Transfer Request List");
                      loadVouchersList("Inventory", "Draft");
                      setGroupBy("SupplierName")
setReportType("General");
                    }}
                  >
                    Transfer Request List
                  </Button>
                </grid> */}
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Transfer Requests Approval List");
                        loadVouchersList("Inventory", "Request");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Transfer Requests Approval List
                    </Button>
                  </grid>

                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Transfer Issues List");
                        loadVouchersList("Inventory", "Order");
                        setGroupBy("CustomerName");
                        setReportType("General");
                      }}
                    >
                      Transfer Issues List
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Transfer Received List");
                        loadVouchersList("Inventory", "Received");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Transfer Received List
                    </Button>
                  </grid>
                 
                </ul>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Inventory" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Inventory",
                      Type: expandReport.Type === "Detail" ? "" : "Detail",
                      Filter: true,
                    });
                  }}
                >
                  Detail Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Inventory" &&
                      expandReport.Type === "Detail" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>
                  {/*   <Grid item xs={12}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Detail Inventory Draft Orders List");
                      loadDetailVouchersList("Inventory", "Draft");
                      setReportType("Detail");
                    }}
                  >
                    Detail Inventory Draft Orders
                  </Button>
                </Grid> */}
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Inventory Requests List");
                        loadDetailVouchersList("Inventory", "Request");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Inventory Requests
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Inventory Orders List");
                        loadDetailVouchersList("Inventory", "Order");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Inventory Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Inventory Received Orders List");
                        loadDetailVouchersList("Inventory", "Received");
                        setGroupBy("CustomerName");
                        setReportType("Detail");
                      }}
                    >
                      Detail Inventory Received Orders
                    </Button>
                  </Grid>

                 
                </Grid>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Inventory" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Inventory",
                      Type: expandReport.Type === "Summary" ? "" : "Summary",
                      Filter: true,
                    });
                  }}
                >
                  Summary Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Inventory" &&
                      expandReport.Type === "Summary" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                {/*  <Grid container>
                    <Grid item xs={12}>
                  <Button
                    variant="standard"
                    onClick={() => {
                      setTableHeader("Sales Draft Orders List");
                      loadVouchersList("Sales", "Draft");
                    }}
                  >
                    Sales Draft Orders
                  </Button>
                </Grid> 
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Quotes List");
                        loadVouchersList("Sales", "Quote");
                      }}
                    >
                      Sales Quotes
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Orders List");
                        loadVouchersList("Sales", "Order");
                      }}
                    >
                      Sales Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Shipped Orders List");
                        loadVouchersList("Sales", "Shipped");
                      }}
                    >
                      Sales Delivery Orders
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Line Items List");
                        loadLineItemsList("Sales", "Shipped");
                        setGroupBy("CustomerName");
                        setReportType("LineItems");
                        setItemVisbile(true);
                      }}
                    >
                      Sales Delivery LineItems
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Sales Payment List");
                        loadPaymentList("Sales");
                      }}
                    >
                      Sales Payment
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Items List");
                      }}
                    >
                      Items
                    </Button>
                  </Grid>
                </Grid> */}
              </Grid>
            </Grid>
          )}
        {globalRoleSecurity.filter(
          (sec) =>
            sec.Functionality === "Administrator Report" &&
            !(sec.Security === 0)
        ).length > 0 && (
            <Grid container p={0.5}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: !expandReport.State,
                      Module: "Administrator",
                      Type: "",
                    });
                  }}
                >
                  Administrator
                </Button>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Administrator" && expandReport.State
                      ? "block"
                      : "none",
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Administrator",
                      Type: expandReport.Type === "General" ? "" : "General",
                      Filter: false,
                    });
                  }}
                >
                  General Reports
                </Button>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Administrator" &&
                      expandReport.Type === "General" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Employees List");
                        loadEmployeesList();
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Employees List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Customers List");
                        loadCustomersList("Customer");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Customers List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Suppliers List");
                        loadCustomersList("Supplier");
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Suppliers List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Items List");
                        loadItemsList();
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Items List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Item Categories List");
                        loadItemCategoriesList();
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Item Categories List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Stores List");
                        loadStoresList();
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Stores List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Stock Balances List");
                        loadStockBalancesList();
                        setGroupBy("Store")
                        setReportType("General");
                      }}
                    >
                      Stock Balances List
                    </Button>
                  </Grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Suppliers' Balance");
                        loadSupplierBalance("Purchase");
                        setGroupBy("Name")
                        setReportType("General");
                      }}
                    >
                      Suppliers Balance
                    </Button>
                  </grid>
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Customers' Balance");
                        loadSupplierBalance("Sales");
                        setGroupBy("Name")
                        setReportType("General");
                      }}
                    >
                      Customers Balance
                    </Button>
                  </grid>
                   
                  <grid item xs={12} style={{ textalign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Items Balance");
                       /*  loadDetailItemHistory(allItems.filter((it) => it.Name == item).length > 0
                          ? allItems.filter((it) => it.Name == item)[0]
                            .Item
                          : 0); */
                          loadStockBalancesList()
                        setGroupBy("Name")
                        setReportType("General");
                      }}
                    >
                      Items Balance
                    </Button>
                  </grid>
                  
                  {/* <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Setting List");
                        loadItemCategoriesList();
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Setting List
                    </Button>
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Security List");
                        loadItemCategoriesList();
                        setGroupBy("SupplierName")
                        setReportType("General");
                      }}
                    >
                      Security List
                    </Button>
                  </Grid> */}
                </Grid>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Administrator" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Administrator",
                      Type: expandReport.Type === "Detail" ? "" : "Detail",
                      Filter: false,
                    });
                  }}
                >
                  Detail Reports
                </Button>
              </Grid>
              <Grid
                item
                p={1}
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Administrator" &&
                      expandReport.Type === "Detail" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>
 <Grid item xs={12}>
                    <Button
                      variant="standard"
                      onClick={() => {
                        setTableHeader("Detail Item History");
                        loadDetailItemHistory(allItems.filter((it) => it.Name == item).length > 0
                          ? allItems.filter((it) => it.Name == item)[0]
                            .Item
                          : 0);
                        setReportType("LineItems");
                        setGroupBy("Name");
                        setItemVisbile(true);
                      }}
                    >
                      Detail Item History
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                p={0.5}
                pl={3}
                xs={12}
                style={{
                  display:
                    expandReport.Module === "Administrator" && expandReport.State
                      ? "block"
                      : "none",
                  m: 4,
                  textAlign: "left",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  endIcon={<ArrowDropDown />}
                  onClick={() => {
                    setExpandReport({
                      State: expandReport.State,
                      Module: "Administrator",
                      Type: expandReport.Type === "Summary" ? "" : "Summary",
                      Filter: false,
                    });
                  }}
                >
                  Summary Reports
                </Button>
              </Grid>
              <Grid
                item
                pl={4}
                style={{
                  display:
                    expandReport.Module === "Administrator" &&
                      expandReport.Type === "Summary" &&
                      expandReport.State
                      ? "block"
                      : "none",
                }}
              >
                <Grid container>

                </Grid>
              </Grid>
            </Grid>
          )}
      </Grid>

      <Grid item xs={10}>
        <Grid container>
          <Grid
            item
            xs={2}
            ml={2}
            style={{
              display: expandReport.Filter ? "block" : "none"

            }}
          >
            <TextField
              size="small"
              type="date"
              variant="standard"
              label="Start Date"
              defaultValue={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
              sx={{ width: "95%", marginBottom: 1 }}
              InputLabelProps={{
                shrink: true,
                sx: {
                  color: theme.palette.primary.contrastText,
                },
              }}
              InputProps={{
                shrink: true,
                sx: {
                  color: theme.palette.primary.contrastText,
                },
              }}
            />
          </Grid>
          <Grid
            item
            xs={2}
            style={{ display: expandReport.Filter ? "block" : "none" }}
          >
            <TextField
              size="small"
              type="date"
              variant="standard"
              label="End Date"
              defaultValue={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
              sx={{ width: "95%", marginBottom: 1 }}
              InputLabelProps={{
                shrink: true,
                sx: {
                  color: theme.palette.primary.contrastText,
                },
              }}
              InputProps={{
                shrink: true,
                sx: {
                  color: theme.palette.primary.contrastText,
                },
              }}
            />

          </Grid>
          {(dataList?.length > 0 || Object.entries(dataList).length) > 0 && expandReport.Filter &&
            <Grid
              item
              xs={2}

            >
              <Button
                size="small"
                variant="standard"
                sx={{ borderRadius: "30px" }}
                endIcon={
                  <Dataset
                    style={{ width: "20px", height: "20px" }}
                  />
                }
                onClick={() => exportToExcel(dataList)}
              >To Excel</Button>
            </Grid>
          }
          <Grid item xs={2} style={{ display: itemVisible ? "block" : "none" }}>
            <Autocomplete
              label="Items"
              id="Items"
              size="small"
              variant="standard"
              value={
                item
                /* allItems.filter((it) => parseInt(it.Item) === parseInt(item))
                  .length > 0
                  ? allItems.filter(
                      (it) => parseInt(it.Item) === parseInt(item)
                    )[0].Name
                  : "" */
              }
              onChange={(e) => {
                setItem(e.target.textContent)
                /*  setItem(
                   allItems.filter((it) => it.Name == e.target.value).length > 0
                     ? allItems.filter((it) => it.Name == e.target.value)[0]
                         .Item
                     : ""
                 ); */
              }}
              options={
                !(allItems === undefined) &&
                  !(allItems === null) &&
                  allItems.length > 0
                  ? allItems.map((it) => {
                    return it.Name;
                  })
                  : [""]
              }
              sx={{ width: "98%", marginBlock: 1 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Selected Item"}
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      color: theme.palette.primary.contrastText,
                    },
                  }}
                //error={!from ? true : false}
                />
              )}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <Button
              size="small"
              variant="standard"
              sx={{ borderRadius: "30px" }}
              endIcon={
                <RefreshSharp
                  style={{ width: "20px", height: "20px" }}
                />
              }
              onClick={() => setUpdate(!update)}
            >Refresh</Button>
          </Grid>
          <Grid
            item
            xs={2}
          >
            <Button
              size="small"
              variant="standard"
              sx={{ borderRadius: "30px" }}
              endIcon={
                <GroupSharp
                  style={{ width: "20px", height: "20px" }}
                />
              }
              onClick={() => setGroupReport(!groupReport)}
            >{groupReport ? "List View" : "Group View"}</Button>
          </Grid>
          <Grid item xs={12}>
            <PDFViewer style={{ width: "100%", height: "800px" }}>
              {expandReport.Module !== "Administrator" ? (
                reportType === "General" ? (groupReport ?

                  <MyGeneralDocumentWithGroup DataList={dataList} /> :
                  <MyGeneralDocument DataList={dataList} />
                ) : reportType === "LineItems" ?
                  (groupReport ?
                    <MyLineItemsDocumentWithGroup DataList={dataList} /> :
                    <MyLineItemsDocument DataList={dataList} />

                  ) : (
                    groupReport ?
                      <MyDetailDocumentWithGroup
                        Orders={dataList}
                        LineItems={lineItemsList}
                      /> : <MyDetailDocument
                        Orders={dataList}
                        LineItems={lineItemsList}
                      />
                  )
              ) : reportType === "General" ?
                groupReport ?
                  <MyAdministratorDocumentWithGroup DataList={dataList} /> :
                  <MyAdministratorDocument DataList={dataList} />

                : (
                  <MyAdministratorDetailDocument DataList={dataList} />
                )}
            </PDFViewer>
            {/* <Apps DataList={dataList} style={{width: '100%', height:'800px'}}/> */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
